import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "./LoadingPage";
import { getSmallModelUrl } from "@/api/beetle";

export default function BeetleDeepLink() {
  const { id } = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    getSmallModelInfo()
  }, [id]);

  const getSmallModelInfo = async () => {
    try {
      if (id) {
        const modelUrl = await getSmallModelUrl(id);
        console.log("modelUrl", modelUrl.data)
        if (modelUrl)
          navigate(`/modelViewer?model=${modelUrl}`);
      }
    } catch (err) {
      console.error(err)
    }
  }

  return <LoadingPage />
}